import { render, staticRenderFns } from "./SendingPolicyRuleCard.vue?vue&type=template&id=bdb26f98&scoped=true"
import script from "./SendingPolicyRuleCard.vue?vue&type=script&lang=js"
export * from "./SendingPolicyRuleCard.vue?vue&type=script&lang=js"
import style0 from "./SendingPolicyRuleCard.vue?vue&type=style&index=0&id=bdb26f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb26f98",
  null
  
)

export default component.exports